import { combineReducers, Reducer } from "redux";
import { castDraft, Draft, produce } from "immer";

import { EMPTY_OBJECT } from "@multiweb/reactUtils";
import { EnumInstance, EnumsInstances, IClearEnumAction, IEnumsState, ILoadEnumsAction, ISetEnumsAction } from "./types";

const INITIAL_ENUM_COUNTER_VALUE = 0;

const INITIAL_ENUM_INSTANCE_STATE: EnumInstance = {
    counter: INITIAL_ENUM_COUNTER_VALUE,
    enumType: null,
};

const counter: Reducer<number> = (state = INITIAL_ENUM_COUNTER_VALUE, action) => {
    if (action instanceof ILoadEnumsAction) {
        return ++state;
    } else if (action instanceof IClearEnumAction) {
        return state > 0 ? --state : state;
    } else {
        return state;
    }
};

export const enumsInstances: Reducer<EnumsInstances> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof ILoadEnumsAction) {
        return produce(state, (draft: Draft<EnumsInstances>) => {
            action.payload.enumsKeys.forEach(enumKey => {
                const reduxEnumType = draft[enumKey];
                draft[enumKey] = {
                    enumType: castDraft(reduxEnumType?.enumType ?? INITIAL_ENUM_INSTANCE_STATE.enumType),
                    counter: counter(reduxEnumType?.counter ?? INITIAL_ENUM_INSTANCE_STATE.counter, action),
                };
            });
        });
    } else if (action instanceof ISetEnumsAction) {
        return produce(state, (draft: Draft<EnumsInstances>) => {
            action.payload.enumTypesWithKeys.forEach(({ enumKey, enumType }) => {
                const enumInstanceDraft: EnumInstance = draft[enumKey];
                if (!enumInstanceDraft) {
                    return state;
                }

                draft[enumKey] = {
                    enumType: castDraft(enumType),
                    counter: counter(enumInstanceDraft.counter, action),
                };

                return draft;
            });
        });
    } else if (action instanceof IClearEnumAction) {
        return produce(state, (draft: Draft<EnumsInstances>) => {
            const enumsKey = action.payload.enumsKey;
            const enumInstanceDraft: EnumInstance = draft[enumsKey];
            if (!enumInstanceDraft) {
                return castDraft(state);
            }

            const count = counter(enumInstanceDraft.counter, action);

            if (count <= 0) {
                delete draft[enumsKey];
            } else {
                draft[enumsKey].counter = count;
            }

            return draft;
        });
    } else {
        return state;
    }
};

export const reducer: Reducer<IEnumsState> = combineReducers({
    enumsInstances,
});
